import React, { useState, useEffect } from "react";
import {
  Box, Typography, Paper, CircularProgress, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Chip,
  TextField, InputAdornment, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { db } from "../firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";

export default function AccessiReferenti() {
  const [accessi, setAccessi] = useState([]);
  const [eventiMap, setEventiMap] = useState({});
  const [corsiMap, setCorsiMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [ricerca, setRicerca] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");

  useEffect(() => {
    const q = query(collection(db, "accessiReferenti"), orderBy("timestamp", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setAccessi(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, []);

  // Mappe id -> titolo per mostrare a quale evento/corso corrisponde l'accesso, senza dover
  // duplicare il titolo su ogni singolo documento di accessiReferenti.
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "eventi"), (snap) => {
      const map = {};
      snap.docs.forEach((d) => { map[d.id] = d.data().titolo; });
      setEventiMap(map);
    });
    return unsub;
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "corsi"), (snap) => {
      const map = {};
      snap.docs.forEach((d) => { map[d.id] = d.data().nome; });
      setCorsiMap(map);
    });
    return unsub;
  }, []);

  function nomeRiferimento(a) {
    if (a.tipo === "corso") return corsiMap[a.riferimentoId] || "—";
    return eventiMap[a.riferimentoId] || "—";
  }

  const accessiFiltrati = accessi.filter((a) => {
    const s = ricerca.toLowerCase();
    const matchRicerca = !s ||
      a.email?.toLowerCase().includes(s) ||
      nomeRiferimento(a).toLowerCase().includes(s);
    const matchTipo = !filtroTipo || a.tipo === filtroTipo;
    return matchRicerca && matchTipo;
  });

  if (loading) return <Box display="flex" justifyContent="center" mt={8}><CircularProgress /></Box>;

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" mb={3}>Accessi referenti</Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Storico degli accessi dei referenti cliente ai report di eventi e corsi (login via OTP).
      </Typography>

      <Box display="flex" gap={2} mb={3} flexWrap="wrap">
        <TextField
          placeholder="Cerca per email o evento/corso..."
          value={ricerca}
          onChange={(e) => setRicerca(e.target.value)}
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
          sx={{ flex: 1, minWidth: 200 }}
          size="small"
        />
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Tipo</InputLabel>
          <Select value={filtroTipo} label="Tipo" onChange={(e) => setFiltroTipo(e.target.value)}>
            <MenuItem value="">Tutti</MenuItem>
            <MenuItem value="evento">Evento</MenuItem>
            <MenuItem value="corso">Corso</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer component={Paper} elevation={1}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f0f4ff" }}>
              <TableCell><strong>Data e ora</strong></TableCell>
              <TableCell><strong>Referente</strong></TableCell>
              <TableCell><strong>Tipo</strong></TableCell>
              <TableCell><strong>Evento / Corso</strong></TableCell>
              <TableCell><strong>IP</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {accessiFiltrati.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4, color: "text.secondary" }}>
                  Nessun accesso trovato
                </TableCell>
              </TableRow>
            ) : (
              accessiFiltrati.map((a) => {
                const timestamp = a.timestamp?.toDate?.();
                const dataOra = timestamp
                  ? timestamp.toLocaleString("it-IT", {
                      day: "2-digit", month: "2-digit", year: "numeric",
                      hour: "2-digit", minute: "2-digit"
                    })
                  : "—";
                return (
                  <TableRow key={a.id} hover>
                    <TableCell>{dataOra}</TableCell>
                    <TableCell>{a.email || "—"}</TableCell>
                    <TableCell>
                      <Chip
                        label={a.tipo === "corso" ? "Corso" : "Evento"}
                        size="small"
                        color={a.tipo === "corso" ? "secondary" : "primary"}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>{nomeRiferimento(a)}</TableCell>
                    <TableCell>{a.ip || "—"}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
